













































import { isEqual } from "lodash-es";
import { defineComponent } from "@vue/composition-api";
import { Currency, InputCurrencyUpdate } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import { $t } from "@/lib/helpers/i18nHelper";
import useAuthorityCheck from "@/hooks/useAuthorityCheck";
import { FormFields, FormValues } from "@/types";
import CurrencyTitle from "@/views/PageSettingsCurrencies/components/CurrencyTitle.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import FormatMoney from "@/components/FormatMoney/FormatMoney";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import BlockBase from "@/components/BlockBase.vue";

export default defineComponent({
  name: "BlockCurrency",
  components: { CurrencyTitle, BlockBaseForm, FormatMoney, BlockBase, ModalConfirm },
  props: {
    currency: { type: Object as () => Currency, required: true },
    mainCurrency: { type: String, required: true },
  },
  data() {
    return {
      showConfirm: false,
      editing: false,
      valid: true,
    };
  },
  setup() {
    const canEdit = useAuthorityCheck("Currency", "update_any");
    return {
      canEdit,
    };
  },
  computed: {
    fields(): FormFields {
      return [
        {
          name: "rate",
          title: $t("Rate per 1.00 {0}", [$t("credit")]),
          value: this.currency.rate,
          validateOnBlur: true,
          rules: [
            v => (v !== "" && !isNaN(Number(v))) || $t("{0} is required", [$t("Rate")]),
            v => Number(v) > 0 || $t("{0} should be greater than zero", [$t("Rate")]),
          ],
        },
      ];
    },
  },
  watch: {
    fields(newFields: FormFields, oldFields: FormFields) {
      if (!isEqual(newFields, oldFields)) {
        this.editing = false;
      }
    },
  },
  methods: {
    save(values: FormValues) {
      const rate = Number(values.rate);
      if (!this.valid) return false;
      const data: InputCurrencyUpdate = {
        name: this.currency.name,
        rate,
      };
      this.$emit("update", data);
    },
    deleteItem() {
      this.$emit("delete", this.currency.name);
    },
  },
});
